import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { CommonService } from '../../../../shared/common.service';
import * as CryptoJS from 'crypto-js'
import { LoansandotherdebsService } from './service/loansandotherdebs.service';
import { Router } from '@angular/router';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';


@Component({
  selector: 'app-loansandotherdebs',
  templateUrl: './loansandotherdebs.component.html',
  styleUrls: ['./loansandotherdebs.component.scss']
})
export class LoansandotherdebsComponent implements OnInit {

  NormalRoutng: boolean;
  LoansandotherdebsFormGroup: FormGroup;
  isJump: any;
  Total: number;
  Total_LY: number;
  showBubbledata: any;

  constructor(public commonService: CommonService, private FormBuilder: FormBuilder, private LoansandotherdebsService: LoansandotherdebsService, private Router: Router, private sidenav: SideNavService) {

  }

  ngOnInit(): void {
    debugger;
    this.commonService.getNotesData();
    this.commonService.getIncomeStatementsHeaders();
    this.createformgroup();
      this.GetLoansandotherdebs();
      this.clearfield();
      this.isJump = localStorage.getItem('isJump')
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.LoansandotherdebsFormGroup.controls['APPeriodId'].value).subscribe((data) => {
      this.commonService.showBubble = data[0].ImportStatus
      if (this.commonService.showBubble) {
        this.sidenav.setShowBubble(true)
        this.GetLoansandotherdebs_LY()
      }
    })
    if (localStorage.getItem("SubmitStatus") == "true")
      this.LoansandotherdebsFormGroup.disable()
  }

  createformgroup() {
    this.LoansandotherdebsFormGroup = this.FormBuilder.group({
      LoansAndOtherDebtsId: new FormControl(),
      NetDebtFunds: new FormControl(),
      NetDebtFunds_LY: new FormControl(),
      LoansFromDirectors: new FormControl(),
      LoansFromDirectors_LY: new FormControl(),
      AmountAnyExpectedReimbursementForProvision: new FormControl(),
      AmountAnyExpectedReimbursementForProvision_LY: new FormControl(),
      AmountsOwedToRelatedParties: new FormControl(),
      AmountsOwedToRelatedParties_LY: new FormControl(),
      AmountsOwedToDirectors: new FormControl({ value: null, disabled: true }),
      AmountsOwedToDirectors_LY: new FormControl({ value: null, disabled: true }),
      CreatedBy: new FormControl(localStorage.getItem('LoginuserId')),
      CreatedDate: new FormControl(),
      ModifiedBy: new FormControl(),
      ModifiedDate: new FormControl(),

      APPeriodId: new FormControl(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)),
      MatchingData: new FormControl(),
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        var MatchingData = this.LoansandotherdebsFormGroup.controls['MatchingData'].value;
        this.LoansandotherdebsFormGroup.reset();
        this.LoansandotherdebsFormGroup.controls['MatchingData'].setValue({ Item1: MatchingData.Item1, Item2: MatchingData.Item2 });
        this.LoansandotherdebsFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
      }
    })
  }

  On_Next() {
    debugger;
    if (this.On_NextIncomestatementValidaton()) {
      this.LoansandotherdebsService.SaveLoansandotherdebs(this.LoansandotherdebsFormGroup.getRawValue()).subscribe((data: any) => {
        this.LoansandotherdebsFormGroup.markAsPristine();
        if (this.NormalRoutng)
          return true;
        var nextPage;
        nextPage = this.commonService.getNextNoteSelection("Loans and other debts due to members", this.commonService.NotesList)
        if (this.isJump == 'true')
          this.Router.navigate(['/notes'])
        else if (nextPage == 'loansandotherdebtsduetomembers') {
          nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
          this.Router.navigate([nextPage]);
        }
        else {
          this.Router.navigate([nextPage]);
        }
      })
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }

  On_Back() {
    debugger;
    this.LoansandotherdebsFormGroup.markAsPristine();
    var backpage;

    if (this.isJump == 'true')
      this.Router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Loans and other debts due to members", this.commonService.NotesList)
      this.Router.navigate([backpage]);
    }
  }

  GetLoansandotherdebs() {
    debugger;
    this.LoansandotherdebsService.GetOneLoansandotherdebs(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data: any) => {
      this.LoansandotherdebsFormGroup.patchValue(data);
      this.LoansandotherdebsFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
    })
  }

  GetLoansandotherdebs_LY() {
    debugger;
    this.LoansandotherdebsService.GetOneLoansandotherdebs_LY(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data: any) => {
      this.showBubbledata = data;
      this.LoansandotherdebsFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
    })
  }

  On_NextIncomestatementValidaton() {
    debugger;
    if (this.commonService.showControl == true) {
      if (+this.LoansandotherdebsFormGroup.controls['AmountsOwedToDirectors'].value != +this.LoansandotherdebsFormGroup.controls['MatchingData'].value.Item1) {
        Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.StartYear + " must tally with the Loans and other debts due to members value in the Balance Sheet for the year  " + this.commonService.StartYear + ".", 'warning');
        return false;
      }
      else if (+this.LoansandotherdebsFormGroup.controls['AmountsOwedToDirectors_LY'].value != +this.LoansandotherdebsFormGroup.controls['MatchingData'].value.Item2) {
        Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.LastYear + " must tally with the Loans and other debts due to members value in the Balance Sheet for the year  " + this.commonService.LastYear + ".", 'warning');
        return false;
      }
      else
        return true
    }
    else {
      if (+this.LoansandotherdebsFormGroup.controls['AmountsOwedToDirectors'].value != +this.LoansandotherdebsFormGroup.controls['MatchingData'].value.Item1) {
        Swal.fire("Andica Accounts Production", "Total value for the year " + this.commonService.StartYear + " must tally with the Loans and other debts due to members value in the Balance Sheet for the year  " + this.commonService.StartYear + ".", 'warning');
        return false;
      }
      else
        return true
    }
  }

  Calculations() {
    debugger;
    this.Total = 0; this.Total_LY = 0;
    this.Total = this.Total + +this.LoansandotherdebsFormGroup.controls['NetDebtFunds'].value + +this.LoansandotherdebsFormGroup.controls['LoansFromDirectors'].value + +this.LoansandotherdebsFormGroup.controls['AmountAnyExpectedReimbursementForProvision'].value
      + +this.LoansandotherdebsFormGroup.controls['AmountsOwedToRelatedParties'].value;
    this.Total_LY = this.Total_LY + +this.LoansandotherdebsFormGroup.controls['NetDebtFunds_LY'].value + +this.LoansandotherdebsFormGroup.controls['LoansFromDirectors_LY'].value + +this.LoansandotherdebsFormGroup.controls['AmountAnyExpectedReimbursementForProvision_LY'].value
      + +this.LoansandotherdebsFormGroup.controls['AmountsOwedToRelatedParties_LY'].value;

    this.LoansandotherdebsFormGroup.controls['AmountsOwedToDirectors'].setValue(this.Total);
    this.LoansandotherdebsFormGroup.controls['AmountsOwedToDirectors_LY'].setValue(this.Total_LY);
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.LoansandotherdebsFormGroup.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          if (this.On_Next())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }


  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.Router.navigate(['/business']);

  }

}
